import React from 'react';
import styles from './ClubOverview.module.css';

export default function ClubOverview({ items, variant }) {
    if (variant === 'hero') {
        return (
            <div className={styles.heroOverview}>
                {items.map((item, index) => (
                    <div key={index} className={styles.heroItem}>
                        <span className={styles.heroLabel}>{item.label}</span>
                        <strong className={styles.heroValue}>{item.value}</strong>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className={styles.overviewGrid}>
            {items.map((item, index) => (
                <div key={index} className={styles.overviewItem}>
                    <span className={styles.label}>{item.label}</span>
                    <strong className={styles.value}>{item.value}</strong>
                </div>
            ))}
        </div>
    );
}
